import { Leg } from 'acscp/store';

/**
 * Description of an airport or a "place" manually entered by broker.
 * Manually entered description might be several things:
 * - city name (meaning any airport in that city)
 * - rarely visited place without normal airport properties (no IATA, ICAO)
 * - in case of Flown trips, this may be a place of emergency landing
 * - ...
 */
export interface Location {
    location: string;
    airportId: string | null;
}

export function locationMatch(location: Location, other: Location): boolean {
    if (location.airportId !== other.airportId) {
        return false;
    }
    return location.airportId !== null || location.location === other.location;
}

export const getDepartureLocation = (flight: Leg) => ({
    location: flight.departureLocation,
    airportId: flight.departureAirportId
});

export const getArrivalLocation = (flight: Leg) => ({
    location: flight.arrivalLocation,
    airportId: flight.arrivalAirportId
});
